import { useEffect, useState } from 'react';
import { useParams, useSearchParams } from 'react-router-dom';

export function HubActivatePage() {
  const { token } = useParams<{ token: string }>();
  const [params] = useSearchParams();
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    // Normalize: strip real whitespace AND literal "\n"/"\r" escape
    // sequences from the last query param. The dev mailer used to log
    // the email body inside an object, which serializes real newlines as
    // the two-character "\n" — copy-paste of the URL from the terminal
    // then carried "\n" into the last query param. The server uses
    // orgHint as the scrypt salt for the invite-token lookup, so a stray
    // "\n" silently breaks it and falls back to production.
    const clean = (s: string | null | undefined): string | undefined =>
      s ? s.replace(/(\\[rn])+$/g, '').trim() : undefined;
    const org = clean(params.get('org'));
    const safeToken = clean(token);
    if (!safeToken || !org) {
      setError('Invalid invitation link.');
      return;
    }
    // orgType used to be carried as a URL param here, but email clients can
    // line-wrap long activation URLs and silently drop trailing params. The
    // server now stamps orgType on the invite row at issue time and peeks it
    // back in /api/auth/connect, so the URL no longer needs it.
    const next =
      `/api/auth/connect?inviteToken=${encodeURIComponent(safeToken)}&role=client-admin&orgHint=${encodeURIComponent(org)}`;
    window.location.replace(next);
  }, [token, params]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-surface-0 text-crux-light">
      <div className="max-w-md text-center px-6">
        <h1 className="text-2xl font-semibold mb-3">OrgIQ Hub</h1>
        {error ? (
          <p className="text-red-400">{error}</p>
        ) : (
          <p className="opacity-70">Activating your invitation, redirecting to Salesforce…</p>
        )}
      </div>
    </div>
  );
}
